import { QuestionBase } from './question-base';
/*

Sample:

new CoursesQuestion({
  key: 'courses',
  label: 'itineraries.courses',
  value: value.publish,
  courses: courses
})

*/

export class CoursesQuestion extends QuestionBase<string> {
  controlType = 'courses';
  owner: string;

  constructor(options: {} = {}) {
    super({ ...options, designSystem: false });
    this.courses = options['courses'] ? options['courses'] : null;
    this.unavailableCourses = options['unavailableCourses'] ? options['unavailableCourses'] : null;
  }
}
